/* THE LIQUOR BURBANK — theme.js */
(function () {
  'use strict';

  /* ── MOBILE NAV ── */
  var burger = document.getElementById('burger');
  var nav    = document.getElementById('mobile-nav');
  function toggleNav() {
    var open = nav.classList.toggle('open');
    burger.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', toggleNav);
  if (nav) nav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ nav.classList.remove('open'); burger.classList.remove('open'); document.body.style.overflow = ''; }); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && nav && nav.classList.contains('open')) toggleNav(); });

  /* ── HEADER SHADOW ON SCROLL ── */
  var hdr = document.getElementById('hdr');
  if (hdr) {
    window.addEventListener('scroll', function(){ hdr.style.boxShadow = window.scrollY > 2 ? '0 1px 0 #e4e4e4' : ''; }, { passive: true });
  }

  /* ── PRODUCT GALLERY THUMBS ── */
  var featuredImg = document.getElementById('pdp-featured');
  document.querySelectorAll('.pdp__thumb').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (featuredImg) featuredImg.src = btn.dataset.src;
      document.querySelectorAll('.pdp__thumb').forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  /* ── PRODUCT ACCORDION ── */
  document.querySelectorAll('.pdp__acc-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var acc = btn.closest('.pdp__acc');
      acc.classList.toggle('open');
    });
  });

  /* ── SCROLL REVEAL ── */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal-section').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal-section').forEach(function(el){ el.classList.add('visible'); });
  }

  /* ── LIVE CART COUNT ── */
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(cart) {
      if (cart) {
        var el = document.getElementById('cart-count');
        if (el) el.textContent = cart.item_count;
      }
    })
    .catch(function(){});

})();

/* — ABOUT US SLIDESHOW — */
(function () {
  function initAboutSlider() {
    var slider = document.getElementById('about-slider');
    if (!slider) return;
    var slides = slider.querySelectorAll('.slide');
    var dots = slider.querySelectorAll('.dot');
    var prev = slider.querySelector('.slide-prev');
    var next = slider.querySelector('.slide-next');
    var current = 0, timer;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.style.opacity = n === current ? '1' : '0'; });
      dots.forEach(function (d, n) { d.style.opacity = n === current ? '1' : '0.4'; });
    }
    function restart() {
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1); }, 4000);
    }

    if (prev) prev.addEventListener('click', function () { show(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(current + 1); restart(); });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { show(n); restart(); });
    });

    show(0);
    restart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAboutSlider);
  } else {
    initAboutSlider();
  }
})();
